import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import Industry from './../components/industry/Industry';
import EnergyUtilitiesData from "./../data/industry/EnergyUtilities.json";
import LifeScienceData from "./../data/industry/LifeScience.json";
import BankingData from "./../data/industry/banking.json";
import ManufacturingData from "./../data/industry/Manufacturing.json";
import HiTechData from "./../data/industry/HiTech.json";
import TravelHospitalityData from "./../data/industry/TravelHospitality.json";
import HealthCareData from "./../data/industry/HealthCare.json";
import { motion } from "motion/react";
const IndustryPage = () => {
    const { name } = useParams();
    const navigate = useNavigate();
    const [hasLoaded, setHasLoaded] = useState(false);
    const [selectedData, setSelectedData] = useState(null);

    const IndustryData = [
        { name: "banking-and-finance", data: BankingData },
        { name: "life-science", data: LifeScienceData },
        { name: "manufacturing", data: ManufacturingData },
        { name: "hi-tech", data: HiTechData },
        { name: "travel-and-hospitality", data: TravelHospitalityData },
        { name: "energy-utilities", data: EnergyUtilitiesData },
        { name: "healthcare", data: HealthCareData },
    ];

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });

        // Validate name (letters, numbers, and hyphens only)
        const isValid = /^[a-zA-Z0-9-]+$/.test(name);
        if (!isValid) {
            navigate("/404", { replace: true });
            return;
        }

        // Find matching industry data
        const filteredData = IndustryData.find(item => item.name === name);
        if (!filteredData) {
            navigate("/404", { replace: true });
            return;
        }

        setSelectedData(filteredData.data);
        setTimeout(() => setHasLoaded(true), 100);
    }, [name, navigate]);

    if (!hasLoaded) {
        return <p></p>;
    }
    return (    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: hasLoaded ? 1 : 0 }}
      transition={{ duration: 0.7 }}
    > <Industry data={selectedData} /> </motion.div>)
};

export default IndustryPage;
